export const TEXT_MODE = {
    INNER :'inner',
    NONE: "none",
}

export const FILTER_NAME = {
    PARTICIPANT: 'participant',
    GENRES: 'genres'

}